import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import {
  InstitutionRankingListQueryParams,
  InstitutionRankingListResponseData,
} from "../../types/institution-ranking";
import { toQueryString } from "../../../common/utils";

export const getData = async (params: InstitutionRankingListQueryParams) => {
  const { data } = await api.get<InstitutionRankingListResponseData>(
    `/institution-ranking${toQueryString(params)}`,
  );

  return data;
};

export const useInstitutionRankings = (
  params: InstitutionRankingListQueryParams,
): QueryObserverBaseResult<InstitutionRankingListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.institutionRankingListPage(params),
    () => getData(params),
  );
  return { data, ...props };
};
